export const USER_LOGIN_REQ="USER_LOGIN_REQ";
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILURE="USER_LOGIN_FAILURE";


export const USER_LOGIN_POST_REQ="USER_LOGIN_POST_REQ";
export const USER_LOGIN_POST_SUCCESS="USER_LOGIN_POST_SUCCESS";
export const USER_LOGIN_POST_FAILURE="USER_LOGIN_POST_FAILURE";

export const USER_LOGOUT_SUCCESS="USER_LOGIN_SUCCESS";